import type { MachineDetail } from "@/features/lines/hooks";
import { CanvasToolbar } from "../CanvasToolbar";
import { AddMachinePopover, type NewMachineBasic } from "../AddMachinePopover";
import type { LayoutNodeType } from "@opus-dt/shared-types";

interface Props {
  machinePickerOpen: boolean;
  setMachinePickerOpen: (open: boolean) => void;
  machines: MachineDetail[];
  usedMachineIds: Set<string>;
  onAddNode: (type: LayoutNodeType) => void;
  onAddMachineFromPicker: (machine: MachineDetail) => void;
  onSave: () => void;
  onCancel: () => void;
  canSave: boolean;
  isDirty: boolean;
  isSaving: boolean;
  saveLabel?: string;
  onCreateNewMachine?: (basic: NewMachineBasic) => void;
}

export function CanvasEditToolbar({
  machinePickerOpen,
  setMachinePickerOpen,
  machines,
  usedMachineIds,
  onAddNode,
  onAddMachineFromPicker,
  onSave,
  onCancel,
  canSave,
  isDirty,
  isSaving,
  saveLabel,
  onCreateNewMachine,
}: Props) {
  return (
    <div className="relative">
      <CanvasToolbar
        onAddNode={onAddNode}
        onAddMachine={() => setMachinePickerOpen(true)}
        onSave={onSave}
        onCancel={onCancel}
        canSave={canSave}
        isDirty={isDirty}
        isSaving={isSaving}
        saveLabel={saveLabel}
      />
      <AddMachinePopover
        open={machinePickerOpen}
        onOpenChange={setMachinePickerOpen}
        machines={machines}
        usedMachineIds={usedMachineIds}
        onSelect={onAddMachineFromPicker}
        onCreateNew={onCreateNewMachine}
      />
    </div>
  );
}
